import React from "react";

function UserTable({ users, session, onEdit, onDelete, onReset }) {
  // ✅ Filter: only admins can see other admins
  const visibleUsers =
    session?.role === "admin" ? users : users.filter((u) => u.role !== "admin");

  if (!visibleUsers || visibleUsers.length === 0) {
    return <p className="text-muted">No users available.</p>;
  }

  return (
    <div className="table-responsive mt-4">
      <table className="table table-striped align-middle">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          {visibleUsers.map((u) => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.name || "-"}</td>
              <td>{u.username || "-"}</td>
              <td>{u.email || "-"}</td>
              <td>{u.role || "user"}</td>
              <td className="text-end">
                {/* Collapsible dropdown for actions */}
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-secondary dropdown-toggle"
                    type="button"
                    id={`dropdown-${u.id}`}
                    data-bs-toggle="dropdown"
                    data-bs-display="static" // ✅ prevents clipping inside table-responsive
                    aria-expanded="false"
                    aria-label={`Actions for ${u.username}`}
                  >
                    Actions
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby={`dropdown-${u.id}`}
                  >
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => onEdit(u)}
                      >
                        Edit
                      </button>
                    </li>
                    {session?.role === "admin" && (
                      <>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => onReset(u.id)}
                          >
                            Reset Password
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item text-danger"
                            onClick={() => onDelete(u.id)}
                          >
                            Delete
                          </button>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserTable;
